export const isFlagEnabled = (identifier) => {
  const flag = localStorage.getItem(`kizen-flag-${identifier}`);

  return flag === 'true';
};
